export const INCREMENT_SIZE: number = 5;
export const DEFAULT_HORIZONTAL_SPACING: number = 33;
export const DEFAULT_VERTICAL_SPACING: number = 100;

export {};
